import { render, staticRenderFns } from "./IndividualMenuTypes.vue?vue&type=template&id=1c73f628"
import script from "./IndividualMenuTypes.vue?vue&type=script&lang=js"
export * from "./IndividualMenuTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports